import Api from './Api';

/**
 * Same rule as `SessionContextValue.isAdmin` / `User.isAdmin`: true when the logged-in
 * user or their super-user is admin (`userType === 1 || superUserType === 1` from auth).
 *
 * For use when React context may be unavailable (e.g. `AppErrorBoundary` after a subtree unmount).
 */
export function shouldShowErrorDetailsFromApiUser(): boolean {
    return Api.user?.isAdmin === true;
}
